import React from 'react';
import Lottieplayer from '../commanComponent/Lottieplayer';
import GluepleAnimation2 from '../../images/UpdatedGluepleAnimation3.json';

const SuspenseSpinner = () => {
  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.6)', // optional translucent background
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
  };

  const animationStyle = {
    width: '120px',
    height: '120px',
  };

  return (
    <div style={overlayStyle}>
      <Lottieplayer
        lottieUrl={GluepleAnimation2}
        Lottiestyle={animationStyle}
      />
    </div>
  );
};

export default SuspenseSpinner;
